/**
 * PublicRoute
 *
 * A wrapper for any Route that restricts access to public users
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Route, Redirect } from 'react-router-dom';
import get from 'lodash.get';

// Selectors
import { selectIsAuthenticated } from '../../../../services/auth/selectors';

const PublicRoute = ({
    component: Component,
    location,
    isAuthenticated,
    ...rest
}) => {
    const to = get(location, 'state.from', { pathname: '/' });
    return (
        <Route
            {...rest}
            render={props =>
                !isAuthenticated ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Redirect to={to} />
                )
            }
        />
    );
};

PublicRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired
};

const mapStateToProps = createStructuredSelector({
    isAuthenticated: selectIsAuthenticated
});

export default connect(mapStateToProps)(PublicRoute);
